import {
  FETCH_REFUND_SCHEDULE,
  FETCH_REFUND_SCHEDULE_SUCCESS,
  FETCH_REFUND_SCHEDULE_FAILURE,
  ADD_REFUND_PERIOD,
  ADD_REFUND_PERIOD_SUCCESS,
  ADD_REFUND_PERIOD_FAILURE,
  UPDATE_REFUND_PERIOD,
  UPDATE_REFUND_PERIOD_SUCCESS,
  UPDATE_REFUND_PERIOD_FAILURE,
  DELETE_REFUND_PERIOD,
  DELETE_REFUND_PERIOD_SUCCESS,
  DELETE_REFUND_PERIOD_FAILURE,
  UPDATE_REFUND_SCHEDULE,
  UPDATE_REFUND_SCHEDULE_SUCCESS,
  UPDATE_REFUND_SCHEDULE_FAILURE,
  CANCEL_PARKING_PERMIT,
  CANCEL_PARKING_PERMIT_SUCCESS,
  CANCEL_PARKING_PERMIT_FAILURE,
} from './types';

const initialState = {
  refundSchedule: null,
  periods: [],
  loading: false,
  error: null,
  cancelLoading: false,
  cancelError: null,
};

const refundScheduleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch refund schedule
    case FETCH_REFUND_SCHEDULE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REFUND_SCHEDULE_SUCCESS:
      return {
        ...state,
        refundSchedule: payload?.schedule || null,
        periods: payload?.periods || [],
        loading: false,
      };
    case FETCH_REFUND_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to fetch refund schedule',
      };

    // Add refund period
    case ADD_REFUND_PERIOD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_REFUND_PERIOD_SUCCESS:
      return {
        ...state,
        periods: [...state.periods, payload],
        loading: false,
      };
    case ADD_REFUND_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to add refund period',
      };

    // Update refund period
    case UPDATE_REFUND_PERIOD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_REFUND_PERIOD_SUCCESS:
      return {
        ...state,
        periods: state.periods.map((p) =>
          p.refundPeriodId === payload.refundPeriodId ? payload : p
        ),
        loading: false,
      };
    case UPDATE_REFUND_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to update refund period',
      };

    // Delete refund period
    case DELETE_REFUND_PERIOD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_REFUND_PERIOD_SUCCESS:
      return {
        ...state,
        periods: state.periods.filter((p) => p.refundPeriodId !== payload),
        loading: false,
      };
    case DELETE_REFUND_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to delete refund period',
      };

    // Update refund schedule header (UseRelativeDates toggle, name, etc.)
    case UPDATE_REFUND_SCHEDULE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_REFUND_SCHEDULE_SUCCESS:
      return {
        ...state,
        refundSchedule: payload || state.refundSchedule,
        loading: false,
      };
    case UPDATE_REFUND_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Failed to update refund schedule',
      };

    // Cancel parking permit
    case CANCEL_PARKING_PERMIT:
      return {
        ...state,
        cancelLoading: true,
        cancelError: null,
      };
    case CANCEL_PARKING_PERMIT_SUCCESS:
      return {
        ...state,
        cancelLoading: false,
      };
    case CANCEL_PARKING_PERMIT_FAILURE:
      return {
        ...state,
        cancelLoading: false,
        cancelError: 'Failed to cancel parking permit',
      };

    default:
      return state;
  }
};

export default refundScheduleReducer;
